import { useUserRole } from '@/hooks/useUserRole';
import { hasGroupSessionAccess } from '@/config/categoryTiers';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '@/components/LoadingSpinner';

interface PractitionerRouteProps {
  children: React.ReactNode;
}

export const PractitionerRoute = ({ children }: PractitionerRouteProps) => {
  const { role, loading } = useUserRole();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!hasGroupSessionAccess(role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};